module.exports = __webpack_public_path__ + "static/media/instructor-new-valuation-model.baa9a56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-new-valuation-model.png
// module id = 2585
// module chunks = 0